export const EXTERNAL_LINKS = {
  AGROSALES: process.env.REACT_APP_AGROSALES_URL,
  WEATHER_SPONSOR: 'https://www.visualcrossing.com',
}
